<template>
    <v-container class="text-xs-center"> 
        <v-layout row wrap justify-center>
            <v-flex xs12 md10>
                <h1>{{$t('labels.hello')}}, {{ currentUser.name }} {{ currentUser.surname }}!</h1>
                <br>
                <v-btn class="home-button" block dark @click.native="$router.push({name: 'species'})">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">group</i> 
                        {{$t('views.Species')}}
                    </div>
                </v-btn><br>
                <v-btn class="home-button" block dark @click.native="$router.push({name: 'researches'})">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">book</i> 
                        {{$t('views.Researches')}}
                    </div>
                </v-btn>
                <br><br>
                <v-btn class="home-button" block dark @click.native="newPassword='';oldPassword='';newPasswordConfirm='';showPasswordResetDialog = true">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">key</i> 
                        {{$t('labels.resetPassword')}}
                    </div>
                </v-btn>
                <br>
                <v-btn class="home-button" block dark @click.native="logout()">
                    <div>
                        <i aria-hidden="true" class="v-icon material-icons theme--light">logout</i> 
                        {{$t('labels.logout')}}
                    </div>
                </v-btn>
            </v-flex>
        </v-layout>
        <v-dialog
            v-model="showPasswordResetDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    <h2>{{$t('labels.resetPassword')}}</h2>
                </v-card-title>
                <v-card-text>
                    {{$t('labels.pwdFor')}} <strong>{{ currentUser.username }}</strong> {{$t('labels.willBeResetted')}}
                    <v-text-field
                        v-model="oldPassword"
                        :label="$t('labels.oldPassword')"
                        type="password"
                    /><br>
                    {{$t('labels.pwdMinLen')}}
                    <v-text-field
                        v-model="newPassword"
                        :label="$t('labels.newPassword')"
                        type="password"
                    />
                    <v-text-field
                        v-model="newPasswordConfirm"
                        :label="$t('labels.confirmNewPassword')"
                        type="password"
                    />
                </v-card-text>
                
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    @click="showPasswordResetDialog = false"
                >
                    {{$t('labels.cancel')}}
                </v-btn>
                <v-btn
                    color="primary"
                    text
                    @click="resetPassword()"
                >
                    {{$t('labels.confirm')}}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import download from "downloadjs";
const axios = require('axios').default;
export default {
    name: 'Home',
    data: function(){
        return{
            currentUser:{
                name:null,
                surname:null
            },
            showPasswordResetDialog: false,
            oldPassword:null,
            newPassword:null,
            newPasswordConfirm:null
        };
    },
    mounted: function(){
        let vm = this;
        vm.getCurrentSession();
    },
    methods:{
        resetPassword(){
            let vm = this;
            if(vm.newPassword!=vm.newPasswordConfirm){
                alert("Nuova password e conferma nuova password non corrispondono!");
                return;
            }
            if(vm.newPassword.length<8){
                alert("La nuova password deve contenere almeno 8 caratteri!");
                return;
            }
            axios({
                method: "POST",
                url: vm.$API_BASE_URL + "users/changePassword.php",
                data: {
                    newPassword: vm.newPassword,
                    oldPassword: vm.oldPassword
                },
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function () {
                vm.showPasswordResetDialog=false;
                vm.$store.commit('toast', "Password modificata!");
            })
            .catch(function (error) {
                alert("Errore durante la modifica password");
            });
        },
        getCurrentSession(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "sessions/getCurrent.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status != 200) {
                    vm.$router.push({name: 'login'});
                } 
                vm.currentUser.name = response.data.user.name;
                vm.currentUser.surname = response.data.user.surname;
                vm.currentUser.username = response.data.user.username;
            })
            .catch(function (error) {
                console.log("Nessuna sessione valida attiva");
                vm.$router.push({name: 'login'});
            });
        },
        logout(){
            let vm = this;
            axios({
                method: "POST",
                url: vm.$API_BASE_URL + "users/logout.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function () {
                vm.$router.push({name: 'login'});
            })
            .catch(function (error) {
                alert("Errore durante il logout");
            });
        },
        downloadWeb() {
            let vm = this;
            axios
                .get(
                    vm.$API_BASE_URL + "downloadReport.php",
                {
                    headers: {
                        'Authentication-Token': window.localStorage.getItem("herp_at")
                    },
                    responseType: "blob",
                }
            )
            .then(async response => {
            const content = response.headers["content-type"];
            vm.savingLoading = false;
            download(
                response.data,
                "pdf",
                content
            );
            })
            .catch(error => {
                alert(JSON.stringify(error))
            });
        },
    }
}
</script>

<style>
    .home-button{
        display: inline-block;
        height: 75px;
        width: calc(49% - 10px);
        min-width: 400px;
        border-radius: 16px;
        vertical-align: middle;
        margin:2px 0 2px 0;
        margin-right:1%;
        padding: 0 5px;
        cursor: pointer;
        background: #4CAF50!important;
        font-size:22px;
        font-weight: 400;
        text-align:left;
    }
    .home-button>div{
        display: block;
        width:90%;
    }
</style>
